import { useState } from "react";
import { Layout,  /*Typography*/ } from "antd";
import { Outlet } from "react-router-dom";
import HeaderLayout from "./components/HeaderLayout";
import SidebarLayout from "./components/SidebarLayout";
import { useIsMobile } from "hooks/useIsMobile";

// const { Title, Text } = Typography;
const { Content } = Layout;

const RecruiterLayout = () => {
  const [visible, setVisible] = useState(false);


  // setVisible(false);

  const isMobile = useIsMobile();

  return (
    <Layout>
      <SidebarLayout visible={visible} setVisible={setVisible} />
      <Layout style={{ height: "100vh" }}>
        <HeaderLayout visible={visible} setVisible={setVisible} />
        <Content
          style={{
            padding: isMobile ? "0px 10px" : "0px 30px",
            marginLeft: `${isMobile ? "0px" : "240px"}`,
            overflow: "auto",
            height: "100vh",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default RecruiterLayout;
